import { createSupabaseClient, type KmgestaoSupabaseClient } from '@kmgestao/supabase-client';

/**
 * Singleton do cliente Supabase tipado. Usa envs `VITE_SUPABASE_URL` e
 * `VITE_SUPABASE_ANON_KEY` (veja `.env.example`).
 *
 * Nunca use `service_role` key no cliente — apenas anon. Operações
 * privilegiadas rodam em Edge Functions do Supabase.
 */
export const supabase: KmgestaoSupabaseClient = createSupabaseClient({
  url: import.meta.env.VITE_SUPABASE_URL,
  anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
});
